import styled from 'styled-components'

export const SpinnerBox = styled.div`
  position: relative;
  height: 100px;
`
